import { buildTrackedFormUrl } from '@components/share-form/helpers';

const DEFAULT_SHARE_SOURCES = [
  { id: 1, label: 'WhatsApp', utmSource: 'whatsapp' },
  { id: 2, label: 'Instagram', utmSource: 'instagram' },
  { id: 3, label: 'Facebook', utmSource: 'facebook' }
];

export const buildMockFormShareLinks = (publicUrl: string) => ({
  data: DEFAULT_SHARE_SOURCES.map((source) => ({
    id: source.id,
    label: source.label,
    form_link: buildTrackedFormUrl(publicUrl, source.utmSource),
    icon_url: ''
  }))
});

export const MOCK_FORM_SHARE_LINKS = buildMockFormShareLinks(
  'https://forms.cofee.life/form_annual_2026'
);
